// https://elvent.shop/wp-admin/admin.php?page=wc-settings&tab=shipping&zone_id=1
export const freeShippingThreshold = 49
export const shippingFee_DE = 4.95
export const shippingFee_AT = 9.74
export const shippingFee_CH = 64.86

export function getShippingFee(price: number, countryCode: "DE" | "AT" | "CH") {
  if (countryCode === "DE") {
    return price > freeShippingThreshold ? 0 : shippingFee_DE
  }
  if (countryCode === "AT") {
    return shippingFee_AT
  }
  if (countryCode === "CH") {
    return shippingFee_CH
  }
  throw new Error(`Unknown country code: ${countryCode}`)
}
